import React from 'react';
import { Section } from './ui/Section';
export function BenefitsSection() {
  return <Section className="bg-navy-800 relative overflow-hidden" dark={true} data-id="element-1">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-gold-600/5 rounded-full blur-3xl" data-id="element-2" />

      <div className="relative z-10 max-w-3xl mx-auto" data-id="element-3">
        <h2 className="text-3xl md:text-4xl font-serif mb-12 text-center" data-id="element-4">
          What makes this different <br data-id="element-5" />
          <span className="text-gold-400 text-2xl md:text-3xl block mt-2" data-id="element-6">
            (and why it works for women 40+)
          </span>
        </h2>

        <div className="space-y-8" data-id="element-7">
          <p className="text-xl text-cream-100/90 text-center mb-12" data-id="element-8">
            Because it respects reality:
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-9">
            {["You're busy.", "You're responsible for other people.", 'Your brain is loud at night.', 'Your sleep is affected by stress and shifting hormones.'].map((item, i) => <div key={i} className="bg-navy-900/50 p-6 rounded-xl border border-navy-700/50 backdrop-blur-sm" data-id="element-10">
                <p className="text-lg font-medium text-cream-50" data-id="element-11">{item}</p>
              </div>)}
          </div>

          <div className="mt-12 p-8 bg-gold-500/10 rounded-2xl border border-gold-500/20 text-center" data-id="element-12">
            <p className="text-xl md:text-2xl font-serif text-cream-50" data-id="element-13">
              This blueprint isn't asking you to become a new person. <br data-id="element-14" />
              <span className="text-gold-400 italic mt-2 block" data-id="element-15">
                It's giving you a new ending to your day.
              </span>
            </p>
          </div>
        </div>
      </div>
    </Section>;
}